angular.module('bmsApp.sm.quote')
	.controller('SMQuoteSaveCtrl', [
		'$log',
		'$state',
		'$stateParams',
		'$scope',
		'$q',
		'notify',
		'LicenseOptionsSvc',
		'QuoteStatusSvc',
		'SiteSvc',
		'TaxHelperSvc',
		'CustomerSvc',
		'SMCleaningServiceSvc',
		'SMJobSvc',
		'SMHouseTemplateSvc',
		'EmployeeSvc',
		'SalesPipelineSvc',
		function ($log,
				  $state,
				  $stateParams,
				  $scope,
				  $q,
				  notify,
				  LicenseOptionsSvc,
				  QuoteStatusSvc,
				  SiteSvc,
				  TaxHelperSvc,
				  CustomerSvc,
				  SMCleaningServiceSvc,
				  SMJobSvc,
				  SMHouseTemplateSvc,
				  EmployeeSvc,
				  SalesPipelineSvc) {

			function init() {
				self.updating = $state.is('main.sm.quote.index.view.update');

				var promises = {
					customerOptions: CustomerSvc.options(),
					licenseOptions: LicenseOptionsSvc.license(),
					quoteStatusOptions: QuoteStatusSvc.options(),
					employeeOptions: EmployeeSvc.index({
						filter: {
							status: true
						}
					}),
					vatRate: TaxHelperSvc.setVatRate()
				};

				if (self.updating) {
					angular.extend(promises, {
						quote: SMJobSvc.read($state.params.quoteId)
					});
				}else if($stateParams.customerId){
					angular.extend(promises, {
						customerPromise : CustomerSvc.read($stateParams.customerId)
					});
 				}


				$q.all(promises)
					.then(function (responses) {
						self.options.license = responses.licenseOptions.data.options;
						self.options.customer = responses.customerOptions.data.options;
						self.options.quoteStatus = responses.quoteStatusOptions.data.options;
						self.options.employee = responses.employeeOptions.data.employee_collection;
						if (self.updating) {
							self.quote = responses.quote.data.sm_job;
							customerChanged();
							calculateEstimatedJobDuration();
						}else if($stateParams.customerId){
							self.quote.customer = responses.customerPromise.data.customer;
							customerChanged();
						}

						initWatches();

						self.loading = false;
					});
			}

			function initWatches() {
				$scope.$watch(function () {
					return self.options.site;
				}, function (newVal, oldVal) {
					// if options have changed, unset site (unless previously undefined)
					if (angular.isArray(oldVal)) {
						self.quote.site = null;
					}
					// if only one choice in new options, set site to that
					if (angular.isArray(newVal) && newVal.length === 1 && angular.isObject(self.quote.site) !== true) {
						self.quote.site = newVal[0];
					}
				});
			}

			function customerChanged() {
				var promises = {
					sites: SiteSvc.customerOptions(self.quote.customer.id),
					pipeline: SalesPipelineSvc.index({
						filter: {
							customer: self.quote.customer.id
						}
					})
				};
				$q.all(promises)
					.then(function (responses) {
						self.options.site = responses.sites.data.options;

						if(self.quote.customer.license){
							self.quote.license = self.quote.customer.license;
						}

						if (!self.updating) {
							if (angular.isObject(responses.pipeline.data.sales_pipelines)) {
								self.quote.sales_pipeline = responses.pipeline.data.sales_pipelines[0];
							}
							else {
								angular.extend(self.quote.sales_pipeline, {
									probability: 0,
									annual_forecast: 0
								});
							}
						}
					});


				generateQuoteName();
			}

			function generateQuoteName() {
				if (!self.updating) {
					if (angular.isObject(self.quote.customer)) {
						var lastName = self.quote.customer.display_name.split(' ')
							.pop()
							.trim()
							.toUpperCase();
						self.quote.quote_name = lastName + '-' + moment()
								.format('MMM-D-YYYY')
								.toUpperCase();
					}
					else {
						self.quote.quote_name = '';
					}
				}
			}

			function addCleaningService() {
				SMCleaningServiceSvc.showCleaningServiceModal(null, self.quote.license_id)
					.then(function (result) {
						angular.extend(result.cleaningService,{
							accepted: true,
							satisfied: true,
						});
						self.quote.scheduled_cleaning_services.push(result.cleaningService);
						calculateEstimatedJobDuration();
					});
			}

			function editCleaningService(item) {
				SMCleaningServiceSvc.showCleaningServiceModal(item, self.quote.license_id)
					.then(function (result) {
						angular.extend(item, result.cleaningService);
					});
			}

			function deleteCleaningService(item) {
				if (item.added) {
					self.quote.scheduled_cleaning_services.splice(self.quote.scheduled_cleaning_services.indexOf(item), 1);
				}
				else {
					angular.extend(item, {
						delete: true
					});
				}
				calculateEstimatedJobDuration();
			}

			function undoDeleteCleaningService(item) {
				angular.extend(item, {
					delete: false
				});
			}

			function selectTemplate() {
				SMHouseTemplateSvc.showSelectTemplateModal()
					.then(function (result) {
						self.quote.scheduled_cleaning_services = [];
						self.quote.scheduled_cleaning_services = result.houseTemplate.cleaning_services;
						calculateEstimatedJobDuration();
					});
			}

			function calculateEstimatedJobDuration() {
				var totalMins = 0;
				angular.forEach(self.quote.scheduled_cleaning_services, function (service) {
					if (service.delete !== true) {
						totalMins += parseFloat(service.cleaning_service.duration_in_mins) || 0;
					}
				});
				self.quote.estimatedTotalMins = totalMins;
			}


			function submit() {
				if (self.formValidator.valid()) {
					var hours = self.quote.hours || 0;
					var mins = self.quote.minutes || 0;
					self.quote.duration_in_mins = (parseFloat(hours) * 60) + parseFloat(mins);
					SMJobSvc.save(self.quote)
						.then(function (response) {
							notify({
								message: 'Successfully saved quote'
							});

							$state.go('main.sm.quote.index.view', {quoteId: response.data.sm_job.id});
						}, function (errors) {
							self.errors = errors;
						});
				}
			}

			$scope.dropzoneErrors = [];
			$scope.dropzone = {
				config: {
					url: 'api/email/upload',
					parallelUploads: 3,
					maxFileSize: 5,
					acceptedFiles: '.csv, .xls, .xlsx, .jpg, .jpeg, .png, .doc, .docx, .pdf',
					eventHandlers: {
						drop: function (event) {
							$scope.dropzoneErrors = [];
						},
						success: function (file, response) {
							if (!angular.isArray(self.quote.documents)) {
								angular.extend(self.quote, {
									documents: []
								});
							}
							self.quote.documents.push(response.filename);
						},
						removedfile: function (file) {
							FileSvc.delete(file.serverFilepath)
								.then(function (response) {
									$log.log('Dropzone file removed');
								}, function (error) {
									$log.error('Failed to remove dropzone file: ' + error);
								});
						},
						error: function (file, errorMessage) {
							$scope.dropzoneErrors.push(errorMessage);
						}
					}
				}
			};

			var self = $scope.SMQuoteSaveCtrl = {
				loading: true,
				processing: false,
				formvalidatorconfig: {},
				formValidator: {},
				quote: {
					scheduled_cleaning_services: []
				},
				options: {},
				methods: {
					init: init,
					submit: submit,
					customerChanged: customerChanged,
					addCleaningService: addCleaningService,
					editCleaningService: editCleaningService,
					deleteCleaningService: deleteCleaningService,
					undoDeleteCleaningService: undoDeleteCleaningService,
					selectTemplate: selectTemplate,
					calculateEstimatedJobDuration: calculateEstimatedJobDuration
				}
			};

		}
	]);
